<template>
  <DashboardWidget
    class="w-100 h-100"
    title="Fabbisogno di Finanziamento"
  >
    <div class="w-100 h-100 d-flex flex-column align-items-center justify-content-center">
      <div class="d-flex align-items-center justify-content-around w-100">
        <div class="text-center">
          <p class="small">Massimo fabbisogno operativo</p>
          <p class="lead">
            <strong>{{ values.maxFabbisognoOperativoAmount }} €</strong> a <strong>{{ values.maxFabbisognoOperativoMonth }}</strong>
          </p>
        </div>
        <div class="text-center">
          <p class="small">Massimo fabbisogno residuo</p>
          <p class="lead">
            <strong>{{ values.maxFabbisognoResiduoAmount }} €</strong> a <strong>{{ values.maxFabbisognoResiduoMonth }}</strong>
          </p>
        </div>
      </div>
    </div>
  </DashboardWidget>
</template>

<script>

import formatMoneyFilter from '../../../../filters/formatMoney';

export default {
  components: {
    DashboardWidget: () => import('./DashboardWidget'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  props: {
    values: {
      type: Object,
      default: () => ({}),
    },
  },
};

</script>
